<template>
	<div class="section-item">
		<div v-if="isLabel" class="section-label">{{t('sidebar.nodeDesign.label.transformation')}}</div>
		<div class="section-row section-row--double-equal section-row--has-locked">
			<div class="row-item">
				<div class="field-row field-row--locked">
					<field-regular
						:label="'W'"
						:aria-label="'W'"
						:label-inline="true"
						:field-classname="'field--w-47 field--w-61:desktop'"
						:unit="'px'"
						:field-item-grow="false"
						:numbers-only="true"
						:max-limit="MAX_NODE_SIZE"
						v-model:model-value="node.width"
					></field-regular>
					<fields-locked
						:disabled="disabled"
						v-model:field1="node.width"
						v-model:field2="node.height"
						:max-limit="MAX_NODE_SIZE"
						:locked="node.locked"
						:unlockable="unlockable"
						:ignore-watch="ignoreLocked"
					></fields-locked>
					<field-regular
						:label="'H'"
						:aria-label="'H'"
						:label-inline="true"
						:field-classname="'field--w-47 field--w-61:desktop'"
						:unit="'px'"
						:field-item-grow="false"
						:numbers-only="true"
            :max-limit="MAX_NODE_SIZE"
						v-model:model-value="node.height"
					></field-regular>
				</div>
			</div>
			<div class="row-item">
				<div
					class="field-row"
					:class="{'tooltip tooltip--centered dark': disabled}"
				>
					<field-regular
						:aria-label="'rotate'"
						:label-icon="'fas fa-redo-alt'"
						:field-classname="'field--w-47 field--w-61:desktop'"
						:label-inline="true"
						:numbers-only="true"
						v-model:model-value="node.rotate"
						:disabled="disabled"
					></field-regular>
					<field-regular
						:label-icon="'fas fa-expand'"
						:unit="'px'"
						:field-classname="'field--w-47 field--w-61:desktop'"
						:numbers-only="true"
						:disabled="true"
						:label-inline="true"
					></field-regular>
					<div v-if="disabled" class="tooltip__item bottom">Available soon</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {computed, reactive} from 'vue';
import FieldRegular from '@/components/fields/FieldRegular';
import FieldsLocked from '@/components/editor-options/settings/sidebar/elements/FieldsLocked';
import {useI18n} from 'vue-i18n';
export default {
	components: {
		FieldRegular,
		FieldsLocked
	},
	props: {
		width: {
			type: Number,
		},
		height: {
			type: Number,
		},
		rotate: {
			type: Number,
		},
		locked: {
			type: Boolean,
			default: true
		},
		unlockable: {
			type: Boolean,
			default: true
		},
		disabled: {
			type: Boolean,
			default: true
		},
		ignoreLocked: {
			type: Boolean,
			default: false
		},
		isLabel: {
			type: Boolean,
			default: true
		}
	},
	setup(props, {emit}) {
		const {t} = useI18n();
    const MAX_NODE_SIZE = 2200;
		const nodeWidth = computed({
			get(){return props.width},
			set(value){
        emit('update:width', value)
      }
		})
		const nodeHeight = computed({
			get(){return props.height},
			set(value){
				emit('update:height', value)}
		})
		const nodeRotate = computed({
			get(){return props.rotate},
			set(value){/*emit('update:rotate', value)*/}
		})
		const nodeLocked = computed({
			get(){return props.locked},
			set(value){emit('update:locked', value)}
		})
		
		const node = reactive({
			width: nodeWidth,
			height: nodeHeight,
			rotate: nodeRotate,
			locked: nodeLocked
		})
		
		return {
			t,
			node,
      MAX_NODE_SIZE
		}
	}
}
</script>

<style lang="scss">

</style>
